import { ChevronDown, Globe, Mail } from 'lucide-react';
import { DropdownMenu, type DropdownMenuItem } from './DropdownMenu';

export interface ContactMoreMenuProps {
  email?: string | null;
  website?: string | null;
}

/** A website as typed, made into an address a browser opens. */
export function websiteUrl(website: string): string {
  return /^https?:\/\//i.test(website) ? website : `https://${website}`;
}

/**
 * A record header's "More" menu for reaching it — email, website. A header
 * leads with one labelled primary action and puts the rest here; the phone
 * number is shown beside the record's details as a `PhoneLink` (call +
 * WhatsApp). Renders nothing when there is nothing to put in it.
 */
export function ContactMoreMenu({ email, website }: ContactMoreMenuProps) {
  const items: DropdownMenuItem[] = [
    ...(email
      ? [
          {
            id: 'email',
            label: 'Email',
            icon: <Mail size={14} />,
            onSelect: () => {
              window.location.href = `mailto:${email}`;
            },
          },
        ]
      : []),
    ...(website
      ? [
          {
            id: 'website',
            label: 'Website',
            icon: <Globe size={14} />,
            onSelect: () => {
              window.open(websiteUrl(website), '_blank', 'noopener,noreferrer');
            },
          },
        ]
      : []),
  ];
  if (items.length === 0) return null;
  return (
    <DropdownMenu
      align="end"
      ariaLabel="More"
      menuClassName="w-44"
      items={items}
      trigger={(props) => (
        <button
          type="button"
          {...props}
          className="flex items-center gap-1.5 px-3 py-2 min-h-11 sm:min-h-0 border border-gray-200 text-gray-700 text-sm rounded-lg hover:bg-gray-50"
        >
          More
          <ChevronDown size={16} />
        </button>
      )}
    />
  );
}
